import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import LocationGroup from '../form/location-group';
import BirthDateGroup from '../form/birth-date-group';
import BirthTimeGroup from '../form/birth-time-group';
import { getBirthDate, getBirthTime, states } from '../../util';
import { MediaQuery as MQ } from '../../media-query';
import _ from 'underscore';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.hasBirthDate = this.props.user && this.props.profile && (
            this.props.user.birth_date
            ||
            this.props.profile.birth_date
        );

        this.state = {
            formError: false,
            birth_date: {
                value: null,
                error: false,
            },
            birth_date_day: {
                value: null,
                error: false,
            },
            birth_date_month: {
                value: null,
                error: false,
            },
            birth_date_year: {
                value: null,
                error: false,
            },
            birth_time: {
                value: null,
                error: false,
            },
            birth_time_hour: {
                value: null,
                error: false,
            },
            birth_time_minute: {
                value: null,
                error: false,
            },
            birth_time_ampm: {
                value: 'am',
                error: null,
            },
            birth_location: {
                country: {
                    value: null,
                    error: false,
                },
                state: {
                    value: null,
                    error: false,
                },
                city: {
                    value: null,
                    error: false,
                },
                city_id: {
                    value: null,
                },
            },
            current_location: {
                country: {
                    value: null,
                    error: false,
                },
                state: {
                    value: null,
                    error: false,
                },
                city: {
                    value: null,
                    error: false,
                },
                city_id: {
                    value: null,
                },
            },
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.user != this.props.user) {
            document.location.reload();
            return false;
        }

        if (nextState != this.state) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        return false;
    }

    /* eslint-disable max-len */
    render() {
        return (
            <vip-profile-form className='is-block has-padding-10-mobile'>
                <h1 className='fancy-title'>More VIP Insight Awaits</h1>
                <p>
                    Add your information below to instantly receive your daily astrological transits (you can update
                    this anytime in the <a href='/member/settings/profiles-manager'>profiles manager</a>).
                </p>
                {this.renderBirthDate()}
                {this.renderBirthTime()}
                <row className='is-wrap'>
                    <column className='is-6 is-12-mobile has-padding-10-right-desktop has-padding-10-right-tablet has-padding-10-bottom'>
                        <LocationGroup
                            prefix='birth'
                            label='Birth'
                            onChange={this.setFormValues}
                            data={this.state.birth_location}
                            refresh={this.state.refreshLocation}
                        />
                    </column>
                    <column className='is-6 is-12-mobile has-padding-10-bottom'>
                        <LocationGroup
                            prefix='current'
                            label='Current'
                            onChange={this.setFormValues}
                            data={this.state.current_location}
                            refresh={this.state.refreshLocation}
                        />
                    </column>
                </row>
                <row>
                    <column className='is-12 has-text-center'>
                        <button className='button-warning' onClick={this.submit}>
                            {this.props.submitting ? 'SUBMITTING...' : 'GET MY DAILY TRANSITS'}
                        </button>
                        {this.renderFormError()}
                    </column>
                </row>
            </vip-profile-form>
        );
    }
    /* eslint-enable max-len */

    renderBirthDate = () => {
        if (this.hasBirthDate) {
            return null;
        }

        return (
            <BirthDateGroup
                name='birth_date'
                label='Birth Date:'
                date={this.state.birth_date}
                month={this.state.birth_date_month}
                day={this.state.birth_date_day}
                year={this.state.birth_date_year}
                onChange={this.setFormValues}
            />
        );
    }

    renderBirthTime = () => {
        if (this.props.user && this.props.user.birth_time) {
            return null;
        }

        return (
            <BirthTimeGroup
                name='birth_time'
                label='Birth Time:'
                time={this.state.birth_time}
                hour={this.state.birth_time_hour}
                minute={this.state.birth_time_minute}
                ampm={this.state.birth_time_ampm}
                onChange={this.setFormValues}
            />
        );
    }

    /* eslint-disable complexity */
    setFormValues = (e) => {
        let state = {
            formError: false,
            refreshLocation: !this.state.refreshLocation,
        };

        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change' || e.type == 'input') {
            if (e.target.type && e.target.type == 'checkbox') {
                if (e.target.checked) {
                    state[e.target.name] = { value: e.target.value, error: false };
                } else {
                    state[e.target.name] = { value: null, error: false };
                }
            } else if (_.contains(['birth_location', 'current_location'], e.target.name)) {
                state[e.target.name] = e.target.value;
            } else {
                state[e.target.name] = { value: e.target.value, error: false };
            }

            if (e.target.name == 'birth_date_month') {
                const month = e.target.value;
                const day = this.state.birth_date_day.value;
                const year = this.state.birth_date_year.value;

                const birth_date = getBirthDate(month, day, year);

                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_date_day') {
                const month = this.state.birth_date_month.value;
                const day = e.target.value;
                const year = this.state.birth_date_year.value;

                const birth_date = getBirthDate(month, day, year);

                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_date_year') {
                const month = this.state.birth_date_month.value;
                const day = this.state.birth_date_day.value;
                const year = e.target.value;

                const birth_date = getBirthDate(month, day, year);

                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_date') {
                const birth_date = dayjs(e.target.value).format('YYYY-MM-DD');
                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_time_hour') {
                const hour = e.target.value;
                const minute = this.state.birth_time_minute.value;
                const ampm = this.state.birth_time_ampm.value;

                const birth_time = getBirthTime(hour, minute, ampm);

                state.birth_time = { value: birth_time, error: false };
            } else if (e.target.name == 'birth_time_minute') {
                const hour = this.state.birth_time_hour.value;
                const minute = e.target.value;
                const ampm = this.state.birth_time_ampm.value;

                const birth_time = getBirthTime(hour, minute, ampm);

                state.birth_time = { value: birth_time, error: false };
            } else if (e.target.name == 'birth_time_ampm') {
                const hour = this.state.birth_time_hour.value;
                const minute = this.state.birth_time_minute.value;
                const ampm = e.target.value;

                const birth_time = getBirthTime(hour, minute, ampm);

                state.birth_time = { value: birth_time, error: false };
            } else if (e.target.name == 'birth_time' && e.target.value == 'unknown') {
                state.birth_time_hour = {
                    value: null,
                    error: false,
                };

                state.birth_time_minute = {
                    value: null,
                    error: false,
                };
            }

            this.setState(state);
        }
    }
    /* eslint-enable complexity */

    submit = (e) => {
        e.preventDefault();
        const formError = this.checkForm();

        if (!formError) {
            this.props.trackEvent(['Site Interaction', 'LI Click', 'VIP Birth Info Form']);
            const payload = {
                set_submitting: true,
                person_1_birth_location: {
                    city: this.state.birth_location.city.value.replace(/ \(.*\)/, ''),
                    county: null,
                    state: this.state.birth_location.state.value,
                    country: this.state.birth_location.country.value,
                    city_id: this.state.birth_location.city_id,
                },
                person_1_location: {
                    city: this.state.current_location.city.value.replace(/ \(.*\)/, ''),
                    county: null,
                    state: this.state.current_location.state.value,
                    country: this.state.current_location.country.value,
                    city_id: this.state.current_location.city_id,
                },
            };

            if (!this.hasBirthDate) {
                payload.person_1_birth_date = this.state.birth_date.value;
            }

            if (this.state.birth_time.value !== 'unknown' && this.state.birth_time.value !== null) {
                payload.person_1_birth_time = this.state.birth_time.value;
            }

            this.props.setSubmitting();
            this.props.updateProfile(payload);
        }
    }

    /* eslint-disable complexity */
    checkForm = () => {
        const state = {
            formError: false,
            refreshLocation: !this.state.refreshLocation,
            birth_location: this.state.birth_location,
            current_location: this.state.current_location,
        };

        if (
            !this.hasBirthDate
            &&
            (
                !this.state.birth_date.value
                ||
                !this.state.birth_date.value.toString().match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)
            )
        ) {
            state.formError = true;
            state.birth_date = {
                value: this.state.birth_date.value,
                error: 'This field is required',
            };

            if (!MQ.isMobile()) {
                if (!this.state.birth_date_month.value) {
                    state.birth_date_month = {
                        value: this.state.birth_date_month.value,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_date_day.value) {
                    state.birth_date_day = {
                        value: this.state.birth_date_day.value,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_date_year.value) {
                    state.birth_date_year = {
                        value: this.state.birth_date_year.value,
                        error: 'This field is required',
                    };
                }
            }
        }

        if (!this.state.birth_location.country.value) {
            state.formError = true;
            state.birth_location.country = {
                value: null,
                error: 'This field is required',
            };
        } else if (states[this.state.birth_location.country.value] && !this.state.birth_location.state.value) {
            state.formError = true;
            state.birth_location.state = {
                value: null,
                error: 'This field is required',
            };
        }

        if (!this.state.birth_location.city.value) {
            state.formError = true;
            state.birth_location.city = {
                value: null,
                error: 'This field is required',
            };
        } else if (!this.state.birth_location.city_id) {
            state.formError = true;
            state.birth_location.city = {
                value: this.state.birth_location.city.value,
                error: 'Please enter a valid city',
            };
        }

        if (!this.state.current_location.country.value) {
            state.formError = true;
            state.current_location.country = {
                value: null,
                error: 'This field is required',
            };
        } else if (states[this.state.current_location.country.value] && !this.state.current_location.state.value) {
            state.formError = true;
            state.current_location.state = {
                value: null,
                error: 'This field is required',
            };
        }

        if (!this.state.current_location.city.value) {
            state.formError = true;
            state.current_location.city = {
                value: null,
                error: 'This field is required',
            };
        } else if (!this.state.current_location.city_id) {
            state.formError = true;
            state.current_location.city = {
                value: this.state.current_location.city.value,
                error: 'Please enter a valid city',
            };
        }

        this.setState({ ...this.state, ...state });

        return state.formError;
    }
    /* eslint-enable complexity */

    renderFormError = () => {
        if (this.state.formError) {
            return (<p className='is-error has-margin-10-top'>Please check required fields above</p>);
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    profile: state.profile,
    submitting: state.product && state.product.submitting,
    location: state.location,
});

const mapDispatchToProps = (dispatch) => ({
    setSubmitting: () => dispatch({ type: 'product:update', payload: { submitting: false } }),
    updateProfile: (payload) => dispatch({ type: 'member:update-profile', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
